import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Row, Popconfirm, Table, Checkbox, Button, Col, Pagination, Select } from 'antd'
import { app, api } from "../../app"
import ReviewSearch from "../../components/ReviewSearch"
import utils from "../../utils"
import _ from "underscore"
import common from "./common"
import config from "../../config"
import NewsDetail from "../../components/NewsDetail"

const Option = Select.Option

class ReNews extends Component {
    constructor (props) {
        super(props)
        this.state = {
            detail_visible: false,
            reviewInfo: {},
            detail_data: {},
            selectedRowKeys: [],
            auditList: [],
            total: 0,
            page: 1,
            dataType: '1',
            dataLevel: '0',
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据源
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { dataType, search_type, search_val, dataLevel } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            level: dataLevel,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.NewsAuditList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].rid).join(',')
        let reviewInfo = {
            id,
            uri: api.NewsReview,
            id_key: "id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            this.props.successReview(1, "", reviewInfo)
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 打开详情
     */
    handleOpenDetail = async (id, rid) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        let { flag, data, msg } = await app.post(api.NewsDetails, {
            id, rid,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        let state = { detail_loading: false }
        if (flag === 1) {
            state.detail_data = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    /**
     * 关闭详情
     */
    handleCancelDetail = () => {
        this.setData({ detail_visible: false })
    }

    render () {
        let { data_loading, detail_loading, detail_data, auditList, total, page, selectedRowKeys, dataType, detail_visible } = this.state,
            tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let columns = [
            {
                title: '封面图片',
                dataIndex: 'news_img',
                key: 'news_img',
                width: '10%',
                render: (img) => {
                    if (img) {
                        let src = config.imgUrl + img
                        return (
                            <a href={src} target='_blank'>
                                <img width={80} height={80} src={src}/>
                            </a>
                        )
                    } else {
                        return '已清除'
                    }
                }

            },
            {
                title: '标题',
                dataIndex: 'news_title',
                key: 'news_title',
                width: '15%',
                render: (title) => (
                    <span title={title}>{title.length > 20 ? title.substr(0, 20) + '...' : title}</span>)
            },
            {
                title: '级别',
                dataIndex: 'object_type',
                key: 'object_type',
                width: '5%',
                render (type) {
                    switch (type) {
                        case '1':
                            return (<span>全国</span>)
                        case '2':
                            return (<span>省级</span>)
                        case '3':
                            return (<span>队伍</span>)
                        default:
                            return ''
                    }
                }
            },
            {
                title: '发布对象',
                dataIndex: 'object',
                key: 'object',
                width: '10%'
            },
            {
                title: '提交时间',
                dataIndex: 'create_time',
                key: 'create_time',
                width: '8%'
            },
            {
                title: '发布人',
                dataIndex: 'vname',
                key: 'vname',
                width: '8%'
            },
            {
                title: '操作类型',
                dataIndex: 'news_status',
                key: 'news_status',
                width: '5%',
                render (_) {
                    switch (_) {
                        case '1':
                            return (<span>添加</span>)
                        case '2':
                            return (<span>编辑</span>)
                        default:
                            return (<span>未知</span>)
                    }
                }
            },
            {
                title: '一级审核',
                dataIndex: 'one_audit',
                key: 'one_audit',
                width: '10%',
                render: (audit, { one_indexno, one_time, detail }) => common.tableStatus(audit, one_indexno, one_time, detail)
            },
            {
                title: '二级审核',
                dataIndex: 'two_audit',
                key: 'two_audit',
                width: '10%',
                render: (audit, { two_indexno, two_time, detail, object_type }) => {
                    if (object_type === '1') {
                        return common.tableStatus(audit, two_indexno, two_time, detail)
                    } else {
                        return (<span>无</span>)
                    }
                }
            },
            {
                title: '三级审核',
                dataIndex: 'three_audit',
                key: 'three_audit',
                width: '10%',
                render: (audit, { three_indexno, three_time, detail, object_type }) => {
                    if (object_type === '1') {
                        return common.tableStatus(audit, three_indexno, three_time, detail)
                    } else {
                        return (<span>无</span>)
                    }
                }
            }
        ], rowSelection = null
        if (dataType === '1') {
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
            columns.push({
                title: '操作',
                dataIndex: 'rid',
                key: 'rid',
                width: '9%',
                render: (rid, { id }) => {
                    let reviewInfo = {
                        id: rid,
                        uri: api.NewsReview,
                        id_key: "id",
                        source: () => this.dataSource(tp),
                    }
                    let disabled = selectedRowKeys.length > 1
                    return (
                        <span>
                            <div>
                                <Button size="small" type="primary"
                                        onClick={() => this.handleOpenDetail(id, rid)}>详情</Button>
                            </div>
                            <div>
                                <Popconfirm placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={() => {
                                                this.props.successReview(1, "", reviewInfo)
                                            }}
                                >
                                    <Button size="small" type="primary" style={{ margin: '10px 0' }}
                                            disabled={disabled}>通过</Button>
                                </Popconfirm>
                            </div>
                            <div>
                                <Button size="small" type="danger" onClick={() => this.props.failReview(reviewInfo)}
                                        disabled={disabled} ghost>不通过</Button>
                            </div>
                        </span>
                    )
                }
            })
        } else {
            columns.push({
                title: '操作',
                dataIndex: 'rid',
                key: 'rid',
                width: '9%',
                render: (rid, { id }) => {
                    return (
                        <Button size="small" type="primary" onClick={() => this.handleOpenDetail(id, rid)}>详情</Button>
                    )
                }
            })
        }

        return (
            <div className="review-info">
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <span style={{ marginLeft: 20 }}>级别选择： </span>
                    <Select defaultValue="0" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataLevel: value })
                        await this.dataSource()
                    }}>
                        <Option value="0">全部</Option>
                        <Option value="1">全国</Option>
                        <Option value="2">省级</Option>
                        <Option value="3">队伍</Option>
                    </Select>

                    <ReviewSearch type='new' onSearch={this.handleSearch}/>
                </div>
                <Table columns={columns}
                       locale={app.tbLocale(data_loading)}
                       dataSource={auditList}
                       loading={data_loading}
                       scroll={{ y: 'calc(100% - 103px)' }}
                       style={{ height: 'calc(100% - 52px)' }}
                       rowSelection={rowSelection}
                       pagination={false}
                       size="small"
                       footer={() => {
                           return (
                               <Row hidden={auditList.length === 0}>
                                   <Col span={10}>
                                       <div hidden={dataType === '2'}>
                                           <Checkbox
                                               checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                               onChange={this.handleAllSel}>全选</Checkbox>
                                           <Button style={{ margin: '0 20px' }} type="primary"
                                                   onClick={() => this.handlePLReview(1)}>通过</Button>
                                           <Button type="danger"
                                                   onClick={() => this.handlePLReview(2)}>不通过</Button>
                                       </div>
                                   </Col>
                                   <Col span={14} style={{ textAlign: 'right' }}>
                                       <Pagination total={total} size="small" pageSize={20} current={page}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handlePageChange}/>
                                   </Col>
                               </Row>
                           )
                       }}
                />
                <Modal
                    visible={detail_visible}
                    footer={null}
                    title="新闻详情"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh' }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={this.handleCancelDetail}
                    className="news-detail-modal-class"
                >
                    <NewsDetail data={detail_data} loading={detail_loading}/>
                </Modal>
            </div>
        )
    }
}

ReNews.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReNews



// WEBPACK FOOTER //
// ./src/routes/review/ReNews.jsx